
export default class Http {

    gatewayUrl = null
    cdnUrl = null
    store = null

    constructor(siteUrl, store) {
        this.protocol = window.location.protocol
        this.gatewayUrl = this.getGatewayUrl(siteUrl)
        this.reactUrl = this.getReactUrl(siteUrl)
        this.cdnUrl = this.getCdnUrl(siteUrl)
        this.store = store
    }

    getGatewayUrl = (siteUrl) => {
        const server = siteUrl.split('.')[0]
        let gateway = null
        if (siteUrl.match(/dev/) || siteUrl.match(/staging/)) {
            return `https://gateway.staging.explori.com`//`gateway.${server}.explori.com`
        } else if (server.match(/qa/)) {
            gateway = 'qa-api.qa.hosting.explori.com'
        } else if (siteUrl === 'tasks.v3.explori.com') {
            gateway = 'gateway.explori.com'
        } else {
            const paths = siteUrl.split('.')
            paths[0] = 'gateway'
            gateway = paths.join('.')
        }
        // return 'http://localhost:3000'
        // return 'https://gateway.v3.hosting.explori.com'
        return `${this.protocol}//${gateway}`
    }

    getCdnUrl = (siteUrl) => {
        const server = siteUrl.split('.')[0]
        let cdn = null
        if (server.match(/dev/) || siteUrl.match(/staging/)) {
            cdn = 'cdn.staging.explori.com' // `gateway.${server}.explori.com`
        } else if (siteUrl === 'tasks.v3.explori.com') {
            cdn = 'cdn.explori.com'
        } else {
            const paths = siteUrl.split('.')
            paths[0] = 'cdn'
            cdn = paths.join('.')
        }
        // return 'http://localhost:3000'
        // return 'https://gateway.v3.hosting.explori.com'
        return `https://${cdn}`
    }

    getReactUrl = (siteUrl) => {
        let server = siteUrl.split('.')
        if (server[0].match(/dev|staging/)) {
            // server[0] = `surveybuilder.${server[0]}`
            // server.join('.')
            server = `${siteUrl}/includes/react`
        } else if (server[0].match(/qa/)) {
            server = 'qa-react.qa.hosting.explori.com'.split('.')
            server.join('.')
        } else {
            // server[0] = 'surveybuilder'
            server = `${siteUrl}/includes/react`
        }
        console.log(`getReactUrl ${server}`)

        return this.protocol + '//' + server
    }

    getHeaders = (method, token) => {
        const headers = new Headers({
            authorization: 'Bearer ' + (token || this.store.token),
        })

        if (method === 'POST' || method === 'PUT') {
            headers.append('Content-Type', 'application/json; charset=UTF-8')
        }

        return headers
    }

    getOptions = (method, token) => {
        const methodMap = {
            POST: 'POST',
            PUT: 'PUT',
            GET: 'GET',
            DELETE: 'DELETE',
            UPLOAD: 'POST',
        }
        return {
            method: methodMap[method] || method,
            headers: this.getHeaders(method, token),
            mode: 'cors',
        }
    }

    validateResponse = async (response) => {
        const status = response.status
        const contentType = response.headers.get("content-type")
        console.log('Response status ' + status)
        if (status >= 200 && status <= 300) {
            return response
        }
        const error = {
            message: 'bad request',
            status,
        }
        if (status === 500) {
            error.message = 'Server error'
        } else if (status === 403) {
            error.message = 'access denied'
        } else if (status === 404) {
            let msg = null
            if (contentType.indexOf('application/json') !== -1) {
                msg = await response.json()
                error.message = `${msg.name}: ${msg.detail}`
            } else {
                msg = await response.text()
                error.message = msg
            }
        } else if (status === 400) {
            let content = null
            const type = (contentType.indexOf('application/json') !== -1)
                ? 'json'
                : 'text'
            if (type === 'json') {
                content = await response.json()
            } else {
                content = await response.text()
            }
            error.message = content
        }

        throw error
    }

    ping = async () => {
        const url = process.env.USE_NEW_LOGIN
            ? '/api/ping'
            : '/srv/ping'
        try {
            fetch(url)
        } catch (e) {}
    }

    request = (url, options, timout) => {
        const that = this
        console.log("request")
        const controller = new AbortController()
        const { signal } = controller
        let timeoutId = null
        if (timout) {
            options.signal = signal
            timeoutId = setTimeout(() => controller.abort(), timout)
        }
        this.ping()
        return new Promise((resolve, reject) => {
            fetch(url, options)
                .then((res) => {
                    if (timeoutId) clearTimeout(timeoutId)
                    return res
                })
                .then(that.validateResponse)
                .then((res) => {
                    let response = null
                    const contentType = res.headers.get('content-type')
                    if (contentType && contentType.indexOf('application/json') !== -1) {
                        response = res.json()
                    } else if (contentType && contentType.indexOf('application/octet-stream') !== -1) {
                        response = res.blob()
                    } else {
                        response = res.text()
                    }
                    return response
                })
                .then(resolve)
                .catch(reject)
        })
    }

    upload = (endpoint, file, headers, token) => {
        const url = this.gatewayUrl + endpoint
        const method = 'UPLOAD'
        const options = this.getOptions(method, token)
        options.headers.append('fileName', headers.fileName)
        if (headers.prevFileName) {
            options.headers.append('prevFileName', headers.prevFileName)
        }
        options.body = file
        console.log("get " + url)
        return this.request(url, options)
    }

    get = (endpoint, token, timeout) => {
        console.log("???")
        const url = this.gatewayUrl + endpoint
        const method = 'GET'
        const options = this.getOptions('GET', token)
        console.log("get " + url)
        return this.request(url, options, timeout)
    }

    post = (endpoint, body, token) => {
        const url = this.gatewayUrl + endpoint
        const method = 'POST'
        const options = this.getOptions('POST', token)
        options.body = body
        return this.request(url, options)
    }

    put = (endpoint, body, token) => {
        const url = this.gatewayUrl + endpoint
        const method = 'PUT'
        const options = this.getOptions('PUT', token)
        options.body = body
        return this.request(url, options)
    }

    delete = (endpoint,token, headers) => {
        const url = this.gatewayUrl + endpoint
        const method = 'DELETE'
        const options = this.getOptions('DELETE', token)

        if (headers) {
            headers.forEach((value, header) => {
                options.headers.append(header, value)
            })
        }

        return this.request(url, options)
    }
}
